module.exports = __webpack_public_path__ + "static/img/fm8.156e53e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm8.jpg
// module id = s/sV
// module chunks = 1